<template>
  <v-app>
    <v-app-bar v-if="mobileVersion" app height="60" color="primary" dark>
      <v-app-bar-nav-icon
        @click.stop="account.drawerLeft = !account.drawerLeft"
      ></v-app-bar-nav-icon>
      <v-spacer></v-spacer>
      <v-app-bar-nav-icon
        @click.stop="account.drawerRight = !account.drawerRight"
      ></v-app-bar-nav-icon>
    </v-app-bar>

    <div @mouseover="isHovering = true" @mouseout="isHovering = false">
      <v-navigation-drawer
        app
        left
        v-model="account.drawerLeft"
        :width="drawerLeftWidth"
        v-if="account.company"
        color="primary"
        class="elevation-4 navDrawerLeft"
        dark
        expand-on-hover
        @update:mini-variant="updateMini"
        mini-variant-width="60"
        style="z-index: 100"
      >
        <div
          v-if="!mobileVersion"
          class="d-flex align-center justify-center primary"
          style="height: 50px"
        >
          <a href="/">
            <img
              v-if="!isHovering"
              src="@/assets/placemint-man.png"
              height="35"
            />
            <img v-else src="@/assets/placemint.png" height="25" />
          </a>
        </div>
        <div
          v-for="item in items"
          :key="item.title"
          class="d-flex"
          :style="
            hoverTarget == item || activeTarget == item || item.title == 'Apps'
              ? 'background-color:' + item.color
              : 'background-color:white'
          "
          @mouseenter="hoverTarget = item"
          @mouseleave="hoverTarget = null"
          @click="changeApp(item)"
          style="height: 50px"
          :to="item.link"
        >
          <div
            :style="'background-color:' + item.color"
            class="d-flex align-center justify-center pa-3"
            style="min-width: 60px"
          >
            <font-awesome-icon
              :icon="item.icon"
              size="lg"
              :style="{ color: 'white' }"
            />
          </div>
          <div
            class="pa-3"
            :style="
              hoverTarget == item ||
              activeTarget == item ||
              item.title == 'Apps'
                ? 'color:white'
                : 'color:black'
            "
          >
            {{ item.title }}
          </div>
        </div>
        <v-divider></v-divider>
        <!-- <v-subheader>Menu</v-subheader> -->
        <v-list v-if="activeTarget" shaped>
          <v-list-item
            v-for="item in menuItems(activeTarget.subItems)"
            :key="item.title"
            link
            :to="item.link"
            :disabled="!canView(item.title)"
          >
            <v-list-item-icon>
              <font-awesome-icon :icon="item.icon" size="lg" />
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title>{{ item.title }}</v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>

        <template v-slot:append>
          <v-divider></v-divider>
          <div
            @mouseover="isHovering = true"
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
              margin: 10px;
            "
          >
            <v-chip class="help-chip" dark color="green" @click="help">
              <span v-show="isHovering" class="mr-2">Help</span>
              <font-awesome-icon icon="question-circle" />
            </v-chip>
            <div
              v-show="isHovering"
              class="version white--text pa-2"
              style="opacity: 0.6"
            >
              v{{ version }}
            </div>
          </div>
        </template>
      </v-navigation-drawer>
    </div>

    <v-main class="background">
      <div class="body">
        <app-alerts />
        <router-view class="content" />
      </div>
    </v-main>
  </v-app>
</template>

<script>
import { mapState, mapActions } from "vuex";
import appAlerts from "./app-alerts.vue";

export default {
  components: {
    appAlerts,
  },
  data: () => ({
    mini: true,
    isHovering: false,
    //data
    hoverTarget: null,
    activeTarget: null,

    userItems: [
      { icon: "cog", title: "Settings", link: "/settings" },
      { icon: "question-circle", title: "Help", link: "/help" },
    ],
  }),
  watch: {
    $route(to, from) {
      this.changePath(to);
    },
    drawerLeft(val) {
      this.toggleDrawerLeft(val);
    },
  },
  computed: {
    ...mapState({
      account: (state) => state.account,
      alert: (state) => state.alert,
      documents: (state) => state.documents,
    }),
    version() {
      return process.env.PACKAGE_VERSION;
    },
    mobileVersion() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    location() {
      return this.account.location;
    },
    locations() {
      return this.account.locations;
    },
    drawerLeftWidth() {
      return this.account.drawerLeftWidth;
    },
    items() {
      return [
        {
          title: "Apps",
          color: "grey",
          icon: "th",
          link: "/",
          subItems: [
            {
              title: "Admin",
              icon: "user-shield",
              link: "/admin",
              admin: true,
              owner: true,
            },
          ],
        },
        {
          title: "Temp",
          color: "#4CAF50",
          icon: "users",
          link: "/temp",
          subItems: [
            {
              title: "Planner",
              icon: "calendar-alt",
              link: "/temp/planner",
              admin: false,
            },
            // {
            //   title: "Planner 2",
            //   icon: "calendar-alt",
            //   link: "/temp/planner2",
            //   admin: false,
            // },

            {
              title: "Candidates",
              icon: "id-card-alt",
              link: "/temp/candidates",
              admin: false,
            },
            {
              title: "Clients",
              icon: "hands-helping",
              link: "/temp/clients",
              admin: false,
            },
            {
              title: "Timesheets",
              icon: "clock",
              link: "/temp/timesheets",
              admin: false,
            },
            {
              title: "Invoices",
              icon: "user-circle",
              link: "/temp/invoices",
              admin: false,
            },
            {
              title: "Analytics",
              icon: "chart-bar",
              link: "/temp/analytics",
              admin: false,
            },
          ],
        },
        {
          title: "Perm",
          color: "#F44336",
          icon: "user-tie",
          link: "/perm",
          subItems: [],
        },
        {
          title: "CRM",
          color: "#FFC107",
          icon: "id-card",
          link: "/crm",
          subItems: [],
        },
      ];
    },
  },
  methods: {
    ...mapActions({
      clearAlert: "alert/clear",
      clearUploading: "alert/clearUploading",
      toggleDrawerLeft: "account/toggleLeftDrawer",
      reload: "account/reload",
    }),
    updateMini(val) {
      // this.mini = val;
    },
    menuItems(subItems) {
      if (this.account.user) {
        if (this.account.user.role === "user") {
          return subItems.filter((item) => !item.admin);
        } else if (this.account.user.role === "admin") {
          return subItems.filter((item) => !item.owner);
        } else if (this.account.user.role === "owner") {
          return subItems;
        }
      } else {
        return [];
      }
    },
    toggleLeftDrawer() {
      this.toggleDrawerLeft();
    },

    changePath(route) {
      if (route.meta.breadcrumbs) {
        var items = route.meta.breadcrumbs.map((crumb) => {
          return {
            text: crumb.name,
            disabled: this.$route.path === crumb.link,
            to: crumb.link,
            exact: true,
          };
        });
        this.account.pathItems = items;

        var path = this.$route.path;
        var item = this.items.find((item) => {
          return path.includes(item.link) && item.link != "/";
        });
        if (item) {
          this.activeTarget = item;
        }
      }
    },
    changeApp(item) {
      this.activeTarget = item;
      this.$router.push(item.link);
    },
    canView(val) {
      var user = this.account.user;
      if (user.role != "user" || this.location.name == "Demo") {
        return true;
      }
      var role = user.roles.find((r) => {
        return r.location == this.location._id;
      });
      if (!role) {
        return false;
      }
      var permission = role.permissions.find((p) => {
        return p.name == val;
      });
      if (!permission) {
        return false;
      }
      if (permission.permission == 0) {
        return false;
      } else {
        return true;
      }
    },
    async init() {
      this.toggleDrawerLeft(this.drawerLeft);
      this.clearAlert();
      this.clearUploading();
      this.changePath(this.$route);

      if (this.account.user && this.account.company) {
        await this.reload();
      }
    },
    help() {
      this.$router.push("/help");
    },
  },
  mounted() {
    this.init();
  },
};
</script>

<style>
.list-active {
  background-color: #6ab4ac;
  color: white;
}

.capitalize {
  text-transform: capitalize;
}

.v-toolbar__content {
  padding: 0px 10px;
}

.v-text-field--filled input {
  margin-top: 5px !important;
  /* margin-bottom: 0px !important; */
  /* max-height: 20px !important; */
}

.body {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  display: flex;
}

.content {
  flex: auto;
  overflow-y: auto;
  background-color: #7169cf07;

  /* max-width: 400px; */
}

.box {
  min-height: -webkit-min-content;
  display: flex;
}
.router-tab__header {
  z-index: 1;
  overflow: scroll !important;
}

.background {
  background-color: #f5f5f5;
  border: none;
}

.navDrawerLeft {
  border-radius: 0 20px 20px 0;
}

.navDrawerRight {
  border-radius: 20px 0px 0px 20px;
}

.v-expansion-panels {
  margin: 10px 0px;
}
</style>

